module.exports = __webpack_public_path__ + "img/flag_kr.513271ac.svg";